module.exports = __webpack_public_path__ + "img/be_careful.29514214.svg";